<template>
  <app-collapse-item
    :title="`من : ${message.full_name}`"
    class="border rounded my-1"
  >
    <template #header>
      <div class="d-flex w-100 justify-content-between align-items-center">
        <h4>من : {{ message.full_name }}</h4>
        <div>
          <feather-icon size="20" icon="ChevronDownIcon" />
        </div>
      </div>
    </template>
    <b-row>
      <b-col cols="6">
        <info-card label="اسم المرسل" :value="message.full_name"> </info-card>
      </b-col>
      <b-col cols="6">
        <!-- <info-card label="البريد الالكتروني" :value="message.email">
        </info-card> -->
        <div class="info-card w-100 px-2 py-1 my-1">
          <div class="d-flex flex-row justify-content-between">
            <h6
              style="width: fit-content; padding: 4px 6px"
              class="bg-info rounded mb-1 text-white font-weight-bold"
            >
              البريد الالكتروني
            </h6>
          </div>
          <div style="white-space: pre-line">
            <a :href="`mailto:${message.email}`">{{ message.email }}</a>
          </div>

          <hr />
        </div>
      </b-col>
      <b-col cols="6">
        <info-card label="رقم الهاتف" :value="message.phone"> </info-card>
      </b-col>
      <b-col cols="6">
        <info-card label="المحافظة" :value="message.governorate.name">
        </info-card>
      </b-col>
      <b-col cols="12">
        <info-card label="الموضوع" :value="message.subject"> </info-card>
      </b-col>
      <b-col cols="12">
        <info-card label="نص الرسالة" :value="message.content"> </info-card>
      </b-col>
    </b-row>
  </app-collapse-item>
</template>

<script>
import InfoCard from "@/components/InfoCard.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { BRow, BCol } from "bootstrap-vue";
export default {
  components: {
    AppCollapseItem,
    InfoCard,
    BRow,
    BCol,
  },
  props: {
    message: Object,
  },
};
</script>
